import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { 
  DashboardHome, 
  UsersView, 
  CategoriesView, 
  AdsView,
  StatesView, 
  QualityManagersView, 
  ApproversView, 
  NewsView, 
  DistrictsView,
  ConstituenciesView
} from './SuperAdminDashboard';
import Article from './Article';
import ReporterList from './ReporterList';
import EditArticle from './EditArticle';

function SuperAdminRoutes({ 
  onEditArticle,
  onBackToNews,
  editingArticleId, 
  setEditingArticleId, 
  editingArticleData, 
  setEditingArticleData,
  onAddReporter
}) {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/superadmin/news" />} />
      {/* Dashboard commented out - redirecting to news instead */}
      {/* <Route path="/dashboard" element={<DashboardHome />} /> */}
      <Route path="/news" element={<NewsView onEditArticle={onEditArticle} />} />
      <Route path="/addnewsarticle" element={<Article />} />
      <Route path="/categories" element={<CategoriesView />} />
      <Route path="/ads" element={<AdsView />} />
      <Route path="/states" element={<StatesView />} />
      <Route path="/districts" element={<DistrictsView />} />
      <Route path="/constituencies" element={<ConstituenciesView />} />
      <Route path="/users" element={<UsersView />} />
      <Route path="/reporters" element={<ReporterList onAddReporter={onAddReporter} />} />
      <Route path="/qualitymanagers" element={<QualityManagersView />} />
      <Route path="/approvers" element={<ApproversView />} />
      <Route path="/editarticle/:id" element={
        editingArticleId ? (
          <EditArticle 
            articleId={editingArticleId} 
            articleData={editingArticleData}
            onBack={onBackToNews}
            userRole="Super Admin"
          />
        ) : (
          <Navigate to="/superadmin/news" />
        )
      } />
      <Route path="*" element={<Navigate to="/superadmin/news" />} />
    </Routes>
  );
}

export default SuperAdminRoutes;
